let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import styled from 'styled-components';
import { IconButton } from '@ovpn-ui/core';
export const MenuToggle = styled(IconButton)(_t || (_t = _`
    position: absolute;
    top: 8px;
    right: 10px;

    background-color: transparent;

    cursor: pointer;

    &:hover {
        background-color: ${0} !important;
    }

    &:focus,
    &:active {
        background-color: ${0} !important;
    }

    svg {
        color: ${0};
    }
`), t => t.theme.itemActiveHoverColor, t => t.theme.itemActiveColor, t => t.theme.text);
export const MobileHeader = styled.div(_t2 || (_t2 = _`
    position: absolute;
    top: var(--sidebar-top-offset, 0px);
    left: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    height: 56px;

    padding: 8px 16px;

    color: ${0};

    background: ${0};

    border-color: ${0};
    border-bottom: 1px solid;
`), t => t.theme.text, t => t.theme.bg, t => t.theme.border);
export const MobileSidebarHeader = styled.div(_t3 || (_t3 = _`
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    width: 100%;
    height: 56px;

    padding: 8px 16px;

    color: ${0};

    background: ${0};

    border-color: ${0};
    border-bottom: 1px solid;
`), t => t.theme.text, t => t.theme.bg, t => t.theme.border);
export const MobileLogo = styled.div(_t4 || (_t4 = _`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`));